import { TTextVariant } from '../Components/Atoms/Text/Text';
import { DesignSystemColor } from '../Components/Styles/Color';

export const assignTextColorStyle = (
  style: React.CSSProperties,
  variant: TTextVariant,
) => {
  switch (variant) {
    case 'primary': {
      Object.assign(style, { color: DesignSystemColor.PrimaryText });
      break;
    }
    case 'black': {
      Object.assign(style, { color: DesignSystemColor.BlackText });
      break;
    }
    case 'disabled': {
      Object.assign(style, { color: DesignSystemColor.DisabledText });
      break;
    }
    case 'white': {
      Object.assign(style, { color: DesignSystemColor.WhiteText });
      break;
    }
    default: {
      Object.assign(style, { color: DesignSystemColor.BlackText });
      break;
    }
  }
};
